import React, { useState, useEffect } from 'react';
import '../../styles/css/ReactionButtons.css'; 

const ReactionButtons = ({onReaction, initialReaction = null}) => {
  const [selectedReaction, setSelectedReaction] = useState(initialReaction);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);

  // Update selected reaction when initialReaction changes
  useEffect(() => {
    if (initialReaction !== null) {
      setSelectedReaction(initialReaction);
    }
  }, [initialReaction]);

  const handleClick = async (reaction) => {
    if (isSubmitting) return;

    if (selectedReaction === reaction) {
      return;
    }
    
    setIsSubmitting(true);
    const previousReaction = selectedReaction;
    setSelectedReaction(reaction);
    
    try {
      await onReaction(reaction);
      // Show thank you message
      setShowThankYou(true);
      setTimeout(() => {
        setShowThankYou(false);
      }, 2000);
    } catch (error) {
      // Reset on error
      setSelectedReaction(previousReaction);
      console.error('Error sending reaction:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="reaction-buttons-container">
      <button
        onClick={() => handleClick('like')}
        disabled={isSubmitting}
        className={`reaction-button ${selectedReaction === 'like' ? 'active' : ''}`}
        title="Like"
      >
        👍
      </button>
      <button
        onClick={() => handleClick('dislike')}
        disabled={isSubmitting}
        className={`reaction-button ${selectedReaction === 'dislike' ? 'active' : ''}`}
        title="Dislike"
      >
        👎
      </button>
      {showThankYou && (
        <span className="reaction-thank-you">
        </span>
      )}
    </div>
  );
};

export default ReactionButtons;
